export const Aux = function(props: any) {
    return props.children;
};
